// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"49c9184c","160":"9cf7564d","453":"130d29ad","558":"6e715b63"}[chunkId] + ".chunk.js";
};